<template>
    <pbl-icon
        class="header-theme-toggle"
        :name="iconName"
        :aria-label="toggleLabel"
        :title="toggleLabel"
        @click="onThemeToggleClick"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'

const { isDarkMode, setDarkMode } = useTheme()

const iconName = computed(() => (isDarkMode.value ? 'sun' : 'moon'))
const toggleLabel = computed(() => (isDarkMode.value ? 'Switch to light mode' : 'Switch to dark mode'))

const onThemeToggleClick = () => {
    setDarkMode(!isDarkMode.value)
}
</script>

<style scoped lang="scss">
.header-theme-toggle {
    cursor: pointer;

    &:hover:not(&:active) {
        color: rgba(255, 255, 255, 0.5);
    }
}
</style>
